import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Health Awareness & Community Outreach',
  category: 'Health & Wellbeing',
  year: '2018',
  location: 'Lagos, Ogun & Osun States',
  heroImage: '/light/assets/imgs/spob/initiative-1.jpg',
  need: {
    headline:
      'Millions in underserved Nigerian communities lack access to basic healthcare information and preventive services.',
    body: 'In many rural and peri-urban communities across South West Nigeria, residents face inadequate access to healthcare facilities, limited awareness of preventive health practices, and a shortage of trained community health workers. This leads to high rates of preventable diseases, poor maternal health outcomes, and late-stage diagnoses that could have been avoided with timely screening and education.',
  },
  approach: {
    headline:
      'SPOB deploys trained community health volunteers to take healthcare directly to the people.',
    body: 'Our Health Awareness & Community Outreach initiative partners with local government health departments and volunteer networks to run free screening camps, maternal and child health workshops, first-aid training sessions, and hygiene education drives. By embedding health education within existing community structures — markets, schools, mosques, and churches — SPOB ensures maximum reach and cultural relevance.',
  },
  stats: [
    { number: '10,000+', label: 'Individuals Screened' },
    { number: '200+', label: 'Communities Reached' },
    { number: '500+', label: 'Health Volunteers Trained' },
  ],
  next: {
    title: 'Nigeria School Uniform Equity Initiative (NSUEI)',
    href: '/light/initiative-nsuei',
  },
};

export default function InitiativeHealth() {
  return <InitiativeDetail initiative={initiative} />;
}
